import { put } from 'redux-saga/effects';
import { hideLoader, showLoader } from 'reducers/popUps/loaderReducer';
import ApiClient from 'Services/ApiClient.js';
import createFetchTypes from 'reducers/utils/createFetchTypes';
import { API_CHANGE_ORGANIZATION_VISIBILITY } from 'config/apiConfig';
import { showAlertAction } from 'reducers/popUps/alertPopUpReducer';
import handleUnauthorizedResponse from 'handlers/handleUnauthorizedResponse';

export const CHANGE_ORGANIZATION_VISIBILITY = createFetchTypes('Marketplace/Administration/OrganizationDirectory/CHANGE_ORGANIZATION_VISIBILITY');

export const setOrganiztionVisibility = {
  base: (params) => ({
    type: CHANGE_ORGANIZATION_VISIBILITY.BASE,
    params
  }),
  request: () => ({
    type: CHANGE_ORGANIZATION_VISIBILITY.REQUEST
  }),
  success: (data) => ({
    type: CHANGE_ORGANIZATION_VISIBILITY.SUCCESS,
    payload: { data }
  }),
  failure: (error) => ({
    type: CHANGE_ORGANIZATION_VISIBILITY.FAILURE,
    payload: {
      error
    }
  })
};

const setOrganiztionVisibilityReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case CHANGE_ORGANIZATION_VISIBILITY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CHANGE_ORGANIZATION_VISIBILITY.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.data
      };

    case CHANGE_ORGANIZATION_VISIBILITY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export function* setOrganizationVisibilityReducerWatcher(action) {
  yield put(showLoader());
  try {
    const response = yield ApiClient.httpClient.put(
      API_CHANGE_ORGANIZATION_VISIBILITY,
      action.params
    );
    yield put(setOrganiztionVisibility.success(response.data));
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      handleUnauthorizedResponse();
    }
    const errorMessage = (error && error.response && error.response.data && error.response.data.responseMessage)
      || 'Unable to change the visibility of the organization. Please try again';
    yield put(setOrganiztionVisibility.failure(error));
    yield put(showAlertAction(errorMessage));
  }
  yield put(hideLoader());
}

export default setOrganiztionVisibilityReducer;
